export default {
  translation: {
    "OrderList.Header.Title": "My Orders List",
    "OrderList.Input.Search": "Order number...",
    "OrderList.Label.Status": "Filter By Spocket Status",

    "order.status.unpaid": "Unpaid",
    "order.status.paid": "Paid",
    "order.status.processing": "Processing",
    "order.status.shipped": "Shipped",
    "order.status.cancelled": "Canceled",
    "order.status.pending": "Pending",
    "order.status.partially_paid": "Partially Paid",
    "order.status.partially_refunded": "Partially Refunded",
    "order.status.refunded": "Refunded",
    "order.status.voided": "Voided",
    "order.status.authorized": "Authorized",
    "order.status.deleted": "Deleted",
    "order.status.pending_payment_confirmation": "Pending",

    "OrderList.Label.DownloadHistory": "Download all order history CSV",
    "OrderList.Document.Title": "Orders - Spocket",
    "OrderList.EmptyOrders.Link.SearchProducts": "Search Products",
    "OrderList.EmptyOrders.Tip.HowToProcessOrders": "How to process orders",
    "OrderList.EmptyOrders.Message.Loading.Title": "Your orders are being loaded!",
    "OrderList.EmptyOrders.Message.Loading.Description": "Please wait while we retrieve your orders.",
    "OrderList.EmptyOrders.Message.Title": "Your orders list is empty!",
    "OrderList.EmptyOrders.Message.Description": "You can manage and process your orders here. Head over to the search page to start adding products to your import list.",
    "OrderList.CheckBox.SelectAllOrders": "Select all orders",
    "OrderList.CheckBox.SelectedXOrders": "{{count}} order selected",
    "OrderList.CheckBox.SelectedXOrders_plural": "{{count}} order selected",
    "OrderList.CheckBox.BulkCheckoutOrders": "Bulk checkout order",
    "OrderList.CheckBox.BulkCheckoutOrders_plural": "Bulk checkout orders",

    "RefreshModal.Button.SynchronizeOrders": "Synchronize Orders",
    "RefreshModal.Button.Cancel": "Cancel",
    "RefreshModal.Button.Synchronize": "Synchronize",
    "RefreshModal.Modal.Body": "Orders are synced automatically from your store. Only sync if order information is missing or has not updated. Please refresh the page after 30 seconds.",

    "Order.Label.OrderNumber" : "Order Number",
    "Order.Label.Date" : "Date",
    "Order.Label.OrderStatus" : "{{integrationName}} Order Status",
    "Order.Table.Th.Product" : "Product",
    "Order.Table.Th.Qty" : "QTY",
    "Order.Table.Th.UnitPrice" : "Unit Price",
    "Order.Table.Th.CheckoutDate" : "Checkout Date",
    "Order.Table.Th.Action" : "Action",

    "CustomerModal.Button.ViewCustomerInfo": "View Customer Info",
    "CustomerModal.Modal.Title.CustomerInfo": "Customer Info",
    "CustomerModal.Modal.Body.CustomerInfo": "Customer Info",
    "CustomerModal.Modal.Body.Address": "Address",

    "OrderLine.Button.Checkout": "Checkout",
    "OrderLine.Tooltip.PreviewInvoice": "Preview Invoice",
    "OrderLine.Tooltip.PaymentReceipt": "Payment Receipt",
    "OrderLine.Tooltip.TrackOrder": "Track Order",
    "OrderLine.Tooltip.OrderProcessing": "Order processing",
    "OrderLine.Tooltip.OrderCancelled": "Order cancelled",
    "OrderLine.Tooltip.PleaseConfirm": "Please click to confirm your order payment",
    "OrderLine.Label.PurchaseEtsy": "Purchase on Etsy",
    "OrderLine.Paying": "Paying",
    "OrderLine.Failure": "Failure",
    "OrderLine.Sample": "Sample",
    "OrderLine.ErrorOrderRow": "Cannot find ordered listing in the system! Please contact support!",

    "ConfirmationModal.Label.OrderDetails": "Order Details",
    "ConfirmationModal.Label.Total": "Total",
    "ConfirmationModal.Label.Shipping": "Shipping",
    "ConfirmationModal.Label.TransactionFees": "Transaction Fees",
    "ConfirmationModal.Tooltip.TransactionFees": "Transaction fees include fees charged by Stripe, Spocket's payment provider as well as service fees.",
    "ConfirmationModal.Modal.OrderConfirmation": "Order Confirmation",
    "ConfirmationModal.Modal.Alert.Attention": "Attention!",
    "ConfirmationModal.Modal.Alert.Description": "This order contains a note from the customer.",
    "ConfirmationModal.Modal.YoureAboutToPlaceOrder": "You are about to place an order for",
    "ConfirmationModal.Modal.Table.Th.Name": "Name",
    "ConfirmationModal.Modal.Table.Th.Price": "Price",
    "ConfirmationModal.Modal.Table.Th.Qty": "QTY",
    "ConfirmationModal.Modal.Table.Th.Total": "Total",
    "ConfirmationModal.Modal.Label.Note": "Note to supplier",
    "ConfirmationModal.Modal.PlaceHolder.Note": "Your message",
    "ConfirmationModal.Button.PlaceOrder": "Place order",

    "PaymentCompleteModal.PaymentCompleted": "Payment Completed",
    "PaymentCompleteModal.PaymentCompleted.Note": "Thanks for the payment. The supplier has been notified and will process the order shortly. We will update the status of the order and add the tracking number in your orders page.",
    "PaymentCompleteModal.PaymentIncomplete": "Your order is incomplete!",
    "PaymentCompleteModal.PaymentIncomplete.BankRequiresConfirmation.Note": "Your bank requires confirmation of your payment to proceed",
    "PaymentCompleteModal.PaymentIncomplete.ConfirmationLink": "Please use this link to confirm the payment.",
    "PaymentCompleteModal.PaymentIncomplete.Note": "Once payment is confirmed, the supplier will be notified and your order will process as normal. Status and tracking updates will be added to your orders page. Please reload the page after confirmation.",

    "SetYourGoalsModal.Title": "Number of products added to the store",
    "SetYourGoalsModal.Subtitle": "A typical store pushes 25 products before getting sales",
    "SetYourGoalsModal.DropdownItem.Product": "{{count}} product",
    "SetYourGoalsModal.DropdownItem.Product_plural": "{{count}} products",
    "SetYourGoalsModal.Button": "Set my goal and start dropshipping",

    "YourGoalsBanner.Container.Description": "Your Goals",
    "YourGoalsBanner.Header.Title": "Starting a business",
    "YourGoalsBanner.Header.Subtitle": "Get your store ready",
    "YourGoalsBanner.Progress.Completed": "Completed",
    "YourGoalsBanner.ProductPushedCount": "<0>Goal: {{goalsNumberOfProduct}}</0> products pushed",
    "YourGoalsBanner.CheckPoints.JoinSpocket": "Join Spocket",
    "YourGoalsBanner.CheckPoints.FirstSearch": "First search",
    "YourGoalsBanner.CheckPoints.ProductsPushed": "{{count}} / {{goalsNumberOfProduct}} Product Pushed",
    "YourGoalsBanner.CheckPoints.ProductsPushed_plural": "{{count}} / {{goalsNumberOfProduct}} Products Pushed",
    "YourGoalsBanner.CheckPoints.ProductsImported": "{{count}} / {{goalsNumberOfProduct}} Product Imported",
    "YourGoalsBanner.CheckPoints.ProductsImported_plural": "{{count}} / {{goalsNumberOfProduct}} Products Imported",

    "Plan.Starter" : "Starter",
    "Plan.Professional": "Professional",
    "Plan.Empire": "Empire",
    "Plan.Unicorn": "Unicorn",

    "Aliscraper.Title": "Automated AliExpress Dropshipping",
    "Aliscraper.Subtitle": "Import thousands of AliExpress products to your eCommerce store with one click and automate your dropshipping business.",
    "Aliscraper.Features.Feature1": "Fast import with one click",
    "Aliscraper.Features.Feature2": "Process hundreds of orders instantly with Spocket",
    "Aliscraper.Features.Feature3": "24/7 Customer Support",
    "Aliscraper.Button": "Download the Extension",
    "Aliscraper.Chrome": "Available in the Chrome Web Store",

    "ConnectStoreModal.Header.Title": "Connect your shop",
    "ConnectStoreModal.Footer.Text": "Choose your platform to get started",
    "ConnectStoreModal.ShopifyForm.UrlText": "Shopify Store URL",
    "ConnectStoreModal.ShopifyForm.InvalidName": "Invalid store name",
    "ConnectStoreModal.ShopifyForm.Placeholder": "e.g MyStore",
    "ConnectStoreModal.ShopifyForm.FooterText": "Don't have a store?",
    "ConnectStoreModal.ShopifyForm.FooterLink": "Try for free",
    "ConnectStoreModal.ShopifyForm.Button": "Connect Store",
    "ConnectStoreModal.WoocommerceInstruction.StoreIdText": "Your Auth key:",
    "ConnectStoreModal.WoocommerceInstruction.Intro": "How to connect your store to Spocket:",
    "ConnectStoreModal.WoocommerceInstruction.Step1": "Install the Spocket plugin from",
    "ConnectStoreModal.WoocommerceInstruction.Step1Link": "here",
    "ConnectStoreModal.WoocommerceInstruction.Step2": "Activate the plugin in your plugins' page",
    "ConnectStoreModal.WoocommerceInstruction.Step3": "Go to WordPress Dashboard > Spocket",
    "ConnectStoreModal.WoocommerceInstruction.Step4": "Paste your Auth key (listed above) click on \"Save\"",
    "ConnectStoreModal.WoocommerceInstruction.Trouble": "Having trouble?",
    "ConnectStoreModal.WoocommerceInstruction.TroubleLink": "Contact us here",
    "ConnectStoreModal.WoocommerceInstruction.Button": "Done",
    "ConnectStoreModal.WixForm.FooterText": "Don't have a store?",
    "ConnectStoreModal.WixForm.FooterLink": "Try for free",
    "ConnectStoreModal.WixForm.Button": "Connect Store",
    "ConnectStoreModal.FelexForm.FooterText": "Don't have a store?",
    "ConnectStoreModal.FelexForm.FooterLink": "Try for free",
    "ConnectStoreModal.FelexForm.Button": "Connect Store",
    "ConnectStoreModal.BigcommerceForm.UrlText": "Bigcommerce Store URL",
    "ConnectStoreModal.BigcommerceForm.InvalidName": "Invalid store name",
    "ConnectStoreModal.BigcommerceForm.Placeholder": "e.g MyStore",
    "ConnectStoreModal.BigcommerceForm.FooterText": "Don't have a store?",
    "ConnectStoreModal.BigcommerceForm.FooterLink": "Try for free",
    "ConnectStoreModal.BigcommerceForm.Button": "Connect Store",

    "PaymentTab.Document.Title": "Settings - Automation - Spocket",
    "PaymentTab.Title.Billing": "Billing",
    "PaymentTab.Tooltip.Billing": "Credit cards will be used for order processing and subscription payments",
    "PaymentTab.AccordionItem.PauseChangeYourPlan": "Pause/Change your plan",
    "PaymentTab.AccordionItem.Label.ChangeYourPlan": "Change your plan",
    "PaymentTab.AccordionItem.Button.Downgrade": "Downgrade",
    "PaymentTab.AccordionItem.Label.PauseYourPlan": "Pause your plan",
    "PaymentTab.AccordionItem.Label.StoreHasBeenPaused": "Your store has already been paused before",
    "PaymentTab.AccordionItem.Button.PauseYourPlan": "Pause your plan",
    "PaymentTab.AccordionItem.Tooltip.PauseStore": "You can pause your Spocket account temporarily and come back at any time without losing any data.",
    "PaymentTab.AccordionItem.Label.RemindMeLater": "Remind me later",
    "PaymentTab.AccordionItem.Button.RemindMeLater": "Remind me later",
    "PaymentTab.AccordionItem.Tooltip.RemindMeLater.3DaysBefore": "3 days before",
    "PaymentTab.AccordionItem.Tooltip.RemindMeLater": "Keep my benefits and remind me <1>{{daysBefore}}</1> my membership renews",
    "RemindMeLaterModal.Header.ReminderSet": "Reminder set",
    "RemindMeLaterModal.Body.DaysBefore": "email you 3 days before",
    "RemindMeLaterModal.Body.ReminderSet": "Your reminder is set and we will <1>{{daysBefore}}</1> your benefits are renewed, until then keep going with your entrepreneurial journey.",
    "RemindMeLaterModal.Button.Continue": "Continue",
    "PauseStoreModal.Title.PauseYourStore": "Pause Your Store",
    "PauseStoreModal.Description.PauseYourStore": "Take advantage of this one-time offer and reduce your plan price by 70% for the next 30 days",
    "PauseStoreModal.Button.PauseStore": "Pause Store",
    "PauseStoreModal.Description.StorePaused": "Your store has been paused and your next month's subscription will be reduced by 70%. Please note, regular payments will resume afterwards.",
    "ConfirmPasswordModal.Title": "Please Confirm Your Password",
    "ConfirmPasswordModal.SubTitle": "For security reasons, please confirm your password",
    "ConfirmPasswordModal.Input.Placeholder": "Your password",
    "ConfirmPasswordModal.Button.Cancel": "Cancel",
    "ConfirmPasswordModal.Button.Confirm": "Confirm",

    "Config.MomentJs.Locale":"en", // List of locales https://stackoverflow.com/a/55827203
    "Config.Plan.Starter":"Starter",
    "Config.Plan.Professional":"Pro",
    "Config.Plan.Empire":"Empire",
    "Config.Plan.Unicorn":"Unicorn",

    "UpgradeConfirmationModal.Header.Title":"Grow faster with Spocket ", // Keep the extra space in the end
    "UpgradeConfirmationModal.Body.Title":"Choose your billing cycle",
    "UpgradeConfirmationModal.BulletPoints.Trial.Initial":"Your first",
    "UpgradeConfirmationModal.BulletPoints.Trial.BeforeNumber":"", // Keep the extra space in the end (if active)
    "UpgradeConfirmationModal.BulletPoints.Trial.AfterNumber":"days ", // Keep the extra space in the end (if active)
    "UpgradeConfirmationModal.BulletPoints.Trial.Final":"are free, cancel during or after your trial",
    "UpgradeConfirmationModal.BulletPoints.FirstBill":"Your first bill will be scheduled for",
    "UpgradeConfirmationModal.BulletPoints.FirstBillNoTrial":"Your first bill will be due upon confirmation",
    "UpgradeConfirmationModal.BulletPoints.Recurrence":"Billing will recur monthly",
    "UpgradeConfirmationModal.MonthlyTab.RateType":"Monthly ", // Keep the extra space in the end
    "UpgradeConfirmationModal.MonthlyTab.RateFrequency":"/month",
    "UpgradeConfirmationModal.YearlyTab.RateType":"Yearly ", // Keep the extra space in the end
    "UpgradeConfirmationModal.YearlyTab.RateFrequency":"/month",
    "UpgradeConfirmationModal.YearlyTab.Discount":"Off",
    "UpgradeConfirmationModal.TaxRates.Text":"sales tax",
    "UpgradeConfirmationModal.TaxRates.Period":"mo",
    "UpgradeConfirmationModal.YearlyPanel.PayNow":"To pay now",
    "UpgradeConfirmationModal.YearlyPanel.PerMonth":"/month X 12 months",
    "UpgradeConfirmationModal.YearlyPanel.Savings":"Your Savings: ", // Keep the extra space in the end
    "UpgradeConfirmationModal.YearlyPanel.Period":"/year",
    "UpgradeConfirmationModal.YearlyPanel.EquivalentInitial":"equivalent to",
    "UpgradeConfirmationModal.YearlyPanel.EquivalentFinal":"% off",
    "UpgradeConfirmationModal.YearlyPanel.Warning.Trial":"Yearly plans do not have a trial period",
    "UpgradeConfirmationModal.YearlyPanel.Warning.Charge":"You will be charged in full immediately",
    "UpgradeConfirmationModal.CreditCardTab.Info":"Pay with credit/debit card",
    "UpgradeConfirmationModal.PayPalTab.Info":"Pay with PayPal",
    "UpgradeConfirmationModal.PaymentSection.Details":"Payment details ", // Keep the extra space in the end
    "UpgradeConfirmationModal.CheckoutButton.FreeTrial":"Claim my free trial",
    "UpgradeConfirmationModal.CheckoutButton.Upgrade":"Upgrade to ", // Keep the extra space in the end
    "UpgradeConfirmationModal.FooterTestA.Info1.Top":"Trusted by 50,000+ Entrepreneurs",
    "UpgradeConfirmationModal.FooterTestA.Info1.Bottom":"Our customers have consistently rated us 5/5.",
    "UpgradeConfirmationModal.FooterTestA.Info2.Top":"128-bit SSL encryption",
    "UpgradeConfirmationModal.FooterTestA.Info2.Bottom":"All your payment details are 100% safe with us.",
    "UpgradeConfirmationModal.FooterTestB.Avatars":"50,000+",
    "UpgradeConfirmationModal.FooterTestB.Info1.Top":"Trusted by 50,000+ Entrepreneurs",
    "UpgradeConfirmationModal.FooterTestB.Info1.Bottom":"Our customers have consistently rated us 5/5.",
    "UpgradeConfirmationModal.FooterTestB.Info2.Top":"128-bit SSL encryption",
    "UpgradeConfirmationModal.FooterTestB.Info2.Bottom":"All your payment details are 100% safe with us.",
    "UpgradeConfirmationModal.Agreement.Intro":"By proceeding, you agree to the " , // Keep the extra space in the end
    "UpgradeConfirmationModal.Agreement.Terms":"Terms of Use",
    "UpgradeConfirmationModal.Agreement.Privacy":"Privacy Policy",
    "UpgradeConfirmationModal.Agreement.Refund":"Refund Policy",
    "UpgradeConfirmationModal.Agreement.Middle":", and",
    "UpgradeConfirmationModal.Agreement.Cancelation":"Cancelation Policy",

    "OrderDetails.Title":"Order details",

    "CreditCard.Update.Label":"Credit Card",
    "CreditCard.Update.InputValue":"Credit card ending in",
    "CreditCard.Update.Button":"Update Card",
    "CreditCard.AddCreditCard.Text":"You have not added any credit card yet. Please add a credit card from the button below to allow us process your orders automatically",
    "CreditCard.AddCreditCard.Button":"Add Credit Card",

    "Sidebar.SearchProducts":"Search Products",
    "Sidebar.WinningProducts":"Winning Products",
    "Sidebar.WinningProducts.Variant":"New",
    "Sidebar.ImportList":"Import List",
    "Sidebar.MyProducts":"My Products",
    "Sidebar.MyOrders":"My Orders",
    "Sidebar.Apps":"Apps",
    "Sidebar.HelpCenter":"Help Center",
    "Sidebar.MyShop":"My Shop",
    "Sidebar.Settings":"Settings",

    "TutorialModal.Title":"We’re here to help you",
    "TutorialModal.WhatIsSpocket":"What is Spocket?",
    "TutorialModal.DiscoverProducts":"Discover Products",
    "TutorialModal.ProductCustomization":"Product Customization",
    "TutorialModal.OrderProcessing":"Order Processing",
    "TutorialModal.Settings":"Settings",
    "TutorialModal.GetHelp":"Get Help",
    "TutorialModal.JoinTheCommunity":"Join the community",

    "NotificationCenter.Header":"Notification Center",
    "NotificationCenter.Footer":"See All Notifications",
    "NotificationCenter.NoNotification":"Nothing to See Here!",

    "Products.Title.Head":"My Products - Spocket", // Page title
    "Products.Title.Header":"My Products",
    "Products.Loading.Top":"Your product list is loading!",
    "Products.Loading.Bottom":"Please wait while we retrieve your products.",
    "Products.Empty.Search":"No products were found!",
    "Products.Empty.Top":"Your product list is empty!",
    "Products.Empty.Bottom":"Head over to the search page to start adding products to your import list.",
    "Products.Empty.Button.Search":"Search Products",
    "Products.Empty.Button.How":"How to find products",
    "Products.Alert.Removed":"Product removed",

    "Products.Search.Label":"Search Your Products",
    "Products.Search.Placeholder":"Keyword",
    "Products.Search.Button":"Search",

    "ProductListItem.Inactive.Tooltip":"This product is no longer available from the supplier",
    "ProductListItem.Inactive.Title":"Inactive",
    "ProductListItem.OutOfStock.Tooltip":"All variations of this product are out of stock",
    "ProductListItem.OutOfStock.Title":"Out of Stock",
    "ProductListItem.InventoryCount.Singular":"piece",
    "ProductListItem.InventoryCount.Plural":"pieces",
    "ProductListItem.InventoryCount.End.Singular":"left",
    "ProductListItem.InventoryCount.End.Plural":"left",
    "ProductListItem.Button.View":"View on Store",
    "ProductListItem.Button.Remove":"Remove From Store",

    "ImportList.Title.Head":"Import List - Spocket", // Page title
    "ImportList.Title.Header":"My Import List",
    "ImportList.Loading.Top":"Your import list is loading!",
    "ImportList.Loading.Bottom":"Please wait while we retrieve your products.",
    "ImportList.Empty.Button.Search":"Search Products",
    "ImportList.Empty.Top":"Your import list is empty!",
    "ImportList.Empty.Bottom":"Head over to the search page to start adding products to your import list.",
    "ImportList.Empty.Button.How":"How to customize products",
    "ImportList.Alert.Pushed":"This product has pushed to your store:",

    "ImportList.Search.Label":"Search through your imported products",
    "ImportList.Search.Placeholder":"Search Your Products",
    "ImportList.Search.Button":"Search",

    "PushAllModal.Button.Active":"Pushing Current Page Products",
    "PushAllModal.Button.Inactive":"Push Current Page",
    "PushAllModal.Modal.Text":"Are you sure you want to push all products from this current page? All of the valid products on the current page will be pushed to your store.",
    "PushAllModal.Modal.Push":"Push All",
    "PushAllModal.Modal.Cancel":"Cancel",

    "RemoveAllModal.Button.Active":"Removing Current Page Products",
    "RemoveAllModal.Button.Inactive":"Remove Current Page",
    "RemoveAllModal.Modal.Text":"Are you sure you want to remove all products from this current page? All of the products on the current page of your will be removed from the import list.",
    "RemoveAllModal.Modal.Remove":"Remove All",
    "RemoveAllModal.Modal.Cancel":"Cancel",

    "ImportListItem.Tab.Product":"Product",
    "ImportListItem.Tab.Description":"Description",
    "ImportListItem.Tab.Variants":"Variants",
    "ImportListItem.Tab.Images":"Images",
    "ImportListItem.Remove.Active":"Removing Product",
    "ImportListItem.Remove.Inactive":"Remove Product",
    "ImportListItem.Push.Active":"Pushing To Store",
    "ImportListItem.Push.Inactive":"Push To Store",
    "ImportListItem.Save.Button":"Save",
    "ImportListItem.Alert.Removed":"This product has been removed from your import list: ",
    "ImportListItem.Alert.RemoveFailed":"Something went wrong trying to remove: ",
    "ImportListItem.Alert.CompareAtPrice":"Compare at price should be greater than sales price for: ",
    "ImportListItem.Alert.OneActiveVariation":"This product needs at least one active variant: ",
    "ImportListItem.Alert.Saved":"This product has been saved: ",
    "ImportListItem.Alert.ErrorPushing":"Something went wrong when pushing to your store",
    "ImportListItem.Alert.ErrorSaving":"Something went wrong when saving your store",
    "ImportListItem.Modal.ConnectStore":"Connect your store to push products: ",
    "ImportListItem.Tooltip.OneActiveVariation":"You need at least one Active Variation",
    "ImportListItem.Tooltip.Unavailable":"This product is currently unavailable for purchase",
    "ImportListItem.Tooltip.Unsaved":"You have unsaved changes",
    "ImportListItem.Tooltip.Profit":"Warning: Your gross profit is negative for this product",
    "ImportListItem.Tooltip.Unpurchasable":"You may save this product, but it is currently unavailable for purchase",

    "ItemInfo.ProductName.Label":"Product Name",
    "ItemInfo.ProductTags.Label":"Product Tags",
    "ItemInfo.ProductTags.Remove":"Remove all tags",
    "ItemInfo.ProductTags.Placeholder":"Add new tag",
    "ItemInfo.ProductType.Label":"Product Type",
    "ItemInfo.Collection.Label":"Collection",
    "ItemInfo.Collection.Placeholder":"Select",
    "ItemInfo.Collection.Option":"Select",

    "ItemVariantList.Modal.Title":"Shipping Details",
    "ItemVariantList.Modal.Intro":"Ships From: ",
    "ItemVariantList.Modal.DoesNotShipInternational":"This item does not ship internationally.",
    "ItemVariantList.Modal.DoesNotShipTo":"Does not ship to: ",
    "ItemVariantList.Table.Head.Destination":"Destination",
    "ItemVariantList.Table.Head.Cost":"Cost",
    "ItemVariantList.Table.Head.Time":"Delivery Time (Days)",
    "ItemVariantList.Table.Body.Domestic":"Domestic",
    "ItemVariantList.Table.Body.International":"International",
    "ItemVariantList.VariantsTable.ShippingPrice":"Shipping Price ", // Keep the extra space in the end
    "ItemVariantList.VariantsTable.Image":"Image",
    "ItemVariantList.VariantsTable.SKU":"SKU",
    "ItemVariantList.VariantsTable.Inventory":"Inventory",
    "ItemVariantList.VariantsTable.Price":"Price",
    "ItemVariantList.VariantsTable.SalesPrice":"Sales Price ", // Keep the extra space in the end
    "ItemVariantList.VariantsTable.Profit":"Profit",
    "ItemVariantList.VariantsTable.CompareAtPrice":"Compare At Price",
    "ItemVariantList.VariantsTable.Unavailable":"This product is currently unavailable for purchase",
    "ItemVariantList.VariantsTable.Head":"All of the variants for this product are shown here.",
    "ItemVariantList.VariantsTable.ContextPopover.Placeholder":"ex: 40%",
    "ItemVariantList.Alert.MaxVariants":"Shopify does not support over 100 variantions.",

    "ItemVariantList.ContextPopover.Title":"Set Profit",
    "ItemVariantList.ContextPopover.Apply":"Apply",

    "ProductVariation.Description": "You can place orders for sample products directly on Spocket. Follow the steps below for a quick easy checkout.",
    "ProductVariation.Label.SelectVariant": "Select variant",
    "ProductVariation.Label.SelectTheProductVariation": "Select the product variation",
    "ProductVariation.Qty": "Qty",
    "ProductVariation.Label.NotesForTheSupplier": "Notes for the supplier",

    "InputAddress.Label.FirstName": "First Name",
    "InputAddress.PlaceHolder.FirstName": "Enter First Name",
    "InputAddress.Label.LastName": "Last Name",
    "InputAddress.PlaceHolder.LastName": "Enter Last Name",
    "InputAddress.Label.StreetAddress": "Street Address",
    "InputAddress.Label.Country": "Country",
    "InputAddress.PlaceHolder.Country": "Search Country",
    "InputAddress.Label.State": "State",
    "InputAddress.Placeholder.State": "Search State",
    "InputAddress.Label.City": "City",
    "InputAddress.PlaceHolder.City": "Enter City",
    "InputAddress.Label.Zip": "Zip",
    "InputAddress.PlaceHolder.Zip": "Enter Zip code",
    "InputAddress.Label.Phone": "Phone Number",
    "InputAddress.Placeholder.Phone": "Enter phone number",

    "OrderReview.OrderDetails": "Order details",
    "OrderReview.Unit": "{{count}} Unit",
    "OrderReview.Unit_plural": "{{count}} Units",
    "OrderReview.ShippingAddress": "Shipping address",
    "OrderReview.PaymentMethod": "Payment method",
    "OrderReview.Amounts": "Amounts",
    "OrderReview.Subtotal": "Subtotal",
    "OrderReview.ShippingCost": "Shipping cost",
    "OrderReview.TransactionFees": "Transaction Fees",
    "OrderReview.TransactionFees.ToolTips": "Transaction fees include fees charged by Stripe, Spocket's payment provider as well as service fees.",
    "OrderReview.OrderTotal": "Order Total",
    "OrderReview.ItemWithCount": "{{count}} item",
    "OrderReview.ItemWithCount_plural": "{{count}} items",
    "OrderReview.Placeholder.CreditCard": "Credit card ending in {{last4}}",

    "PaymentComplete.PaymentCompleted": "Payment Completed",
    "PaymentComplete.PaymentCompleted.Note": "Thanks for the payment. The supplier has been notified and will process the order shortly. We will update the status of the order and add the tracking number in your orders page.",
    "PaymentComplete.PaymentIncomplete": "Your order is incomplete!",
    "PaymentComplete.PaymentIncomplete.BankRequiresConfirmation.Note": "Your bank requires confirmation of your payment to proceed",
    "PaymentComplete.PaymentIncomplete.ConfirmationLink": "Please use this link to confirm the payment.",
    "PaymentComplete.PaymentIncomplete.Note": "Once payment is confirmed, the supplier will be notified and your order will process as normal. Status and tracking updates will be added to your orders page. Please reload the page after confirmation.",

    "CreditCard.AddCreditCard.Description": "You have not added any credit card yet. Please add a credit card from the button below to allow us process your orders automatically",
    "CreditCard.Button.AddCreditCard": "Add Credit Card",
    "CreditCard.Button.UpdateCard": "Update Card",
    "CreditCard.UpdateCard.Label.CreditCard": "Credit Card",
    "CreditCard.PlaceHolder.CreditCard": "Credit card ending in {{last4}}",

    "UpdateCreditCardModal.Label.CreditCard": "Credit Card",
    "UpdateCreditCardModal.Button.UpdateCard": "Update Card",
    "UpdateCreditCardModal.Button.AddCreditCard": "Add Credit Card",
    "UpdateCreditCardModal.Button.Cancel": "Cancel",
    "UpdateCreditCardModal.Label.UpdateCardDetails": "Update your card details",
    "UpdateCreditCardModal.Label.TermsAndConditionsNote.One": "Your account will be used during order processing of Spocket products.",
    "UpdateCreditCardModal.Label.TermsAndConditionsNote.Two": "Terms and conditions",
    "UpdateCreditCardModal.Label.TermsAndConditionsNote.Three": "for processing payments.",

    "SampleOrderModal.Title.SelectVariation": "Select Variation",
    "SampleOrderModal.Title.ShippingAddress": "Shipping Address",
    "SampleOrderModal.Title.PaymentMethod": "Payment Method",
    "SampleOrderModal.Title.Review": "Review",
    "SampleOrderModal.Title.PaymentConfirmationRequired": "Payment Confirmation Required!",
    "SampleOrderModal.Title.OrderPlaced": "Order Placed!",
    "SampleOrderModal.Steps": "Step {{current}} of {{total}}",
    "SampleOrderModal.FinalStep": "Final Step",
    "SampleOrderModal.ConfirmPayment": "Confirm Payment!",
    "SampleOrderModal.Finished": "Finished",
    "SampleOrderModal.Footer.Continue": "Continue",
    "SampleOrderModal.Footer.PlaceOrder": "Place order",
    "SampleOrderModal.Footer.Close": "Close",
    "SampleOrderModal.Footer.Cancel": "Cancel",
    "SampleOrderModal.Footer.GoBack": "Go Back",

    "RatingCaptureModal.EnjoyingSpocket": "Enjoying Spocket?",
    "RatingCaptureModal.TapAStar": "Tap a star to rate it on the App Store",

    "AdvancedFiltersModal.Title.Filters": "Filters",
    "AdvancedFiltersModal.Title.Shipping": "Shipping",
    "AdvancedFiltersModal.Label.ShipsFrom": "Ships from",
    "AdvancedFiltersModal.Label.ShipsTo": "Ships to",
    "AdvancedFiltersModal.Label.ShippingTime": "Shipping time",
    "AdvancedFiltersModal.Label.Popular": "Popular",
    "AdvancedFiltersModal.Label.Country.UnitedStates": "United States",
    "AdvancedFiltersModal.Label.Country.Europe": "Europe",
    "AdvancedFiltersModal.Label.ShippingTimeDescription": "Only available for shipment to the US",
    "AdvancedFiltersModal.RadioOption.ShippingTime.Any": "Any Days",
    "AdvancedFiltersModal.RadioOption.ShippingTime.One": "1-3 Days",
    "AdvancedFiltersModal.RadioOption.ShippingTime.Four": "4-7 Days",
    "AdvancedFiltersModal.RadioOption.ShippingTime.Eight": "8-14 Days",
    "AdvancedFiltersModal.RadioOption.ShippingTime.Fifteen": "15+ Days",
    "AdvancedFiltersModal.Title.ItemsCost": "Items cost",
    "AdvancedFiltersModal.Label.ItemCost": "Item cost",
    "AdvancedFiltersModal.Label.ShippingCost": "Shipping cost",
    "AdvancedFiltersModal.RadioOption.ShippingCost.Any": "Any Cost",
    "AdvancedFiltersModal.RadioOption.ShippingCost.Free": "Free",
    "AdvancedFiltersModal.RadioOption.ShippingCost.Five": "$5 and less",
    "AdvancedFiltersModal.RadioOption.ShippingCost.Fifteen": "$15 and less",
    "AdvancedFiltersModal.RadioOption.ShippingCost.TwentyFive": "$25 and less",
    "AdvancedFiltersModal.Title.Supplier": "Supplier",
    "AdvancedFiltersModal.Select.MenuTitle.Suppliers": "Suppliers",
    "AdvancedFiltersModal.Label.TopSupplier": "Top supplier",
    "AdvancedFiltersModal.Label.TopSupplierDescription": "Suppliers known for their high-quality products, great service and high ratings reviews",
    "AdvancedFiltersModal.Title.Advanced": "Advanced",
    "AdvancedFiltersModal.Checkbox.Label.PremiumProducts": "Premium products",
    "AdvancedFiltersModal.Checkbox.Label.PremiumProductsDescription": "Highly discounted and fast shipping products",
    "AdvancedFiltersModal.Checkbox.Label.BestSeller": "Best Seller",
    "AdvancedFiltersModal.Checkbox.Label.BestSellerDescription": "Top performing products on Spocket",
    "AdvancedFiltersModal.Button.Cancel": "Cancel",
    "AdvancedFiltersModal.Button.ViewResults": "View Results",
    "AdvancedFiltersModal.Select.PlaceHolder.Countries": "Search Country…",
    "AdvancedFiltersModal.Select.MenuTitle.Countries": "Countries",
    "AdvancedFiltersModal.Select.PlaceHolder.Suppliers": "Search Supplier…",
    "AdvancedFiltersModal.Label.All Suppliers": "All Suppliers",
    "AdvancedFiltersModal.Label.New Suppliers": "New Suppliers",

    "AdvancedFilters.ShippingTime.Any": "Any Days",
    "AdvancedFilters.ShippingTime.One": "1-3 Days",
    "AdvancedFilters.ShippingTime.Four": "4-7 Days",
    "AdvancedFilters.ShippingTime.Eight": "8-14 Days",
    "AdvancedFilters.ShippingTime.Fifteen": "15+ Days",

    "AdvancedFilters.ShippingCost.Free": "Free Shipping",
    "AdvancedFilters.ShippingCost.Five": "Shipping Under $5",
    "AdvancedFilters.ShippingCost.Fifteen": "Shipping Under $15",
    "AdvancedFilters.ShippingCost.TwentyFive": "Shipping Under $25",

    "AdvancedFilters.transpileFiltersKey.Label.ClearAll": "Clear All",
    "AdvancedFilters.transpileFiltersKey.Label.Shipping": "Shipping",
    "AdvancedFilters.transpileFiltersKey.Label.Keywords": "Search",
    "AdvancedFilters.transpileFiltersKey.Label.ShipsFrom": "Ships From",
    "AdvancedFilters.transpileFiltersKey.Label.ShipsTo": "Ships To",
    "AdvancedFilters.transpileFiltersKey.Label.Supplier": "Supplier",
    "AdvancedFilters.transpileFiltersKey.Label.SortBy": "Sort By",
    "AdvancedFilters.transpileFiltersKey.Label.ItemCost": "Item Cost",
    "AdvancedFilters.transpileFiltersKey.Value.TopSuppliers": "Top Suppliers",
    "AdvancedFilters.transpileFiltersKey.Value.PersonalizedInvoices": "Personalized Invoices",
    "AdvancedFilters.transpileFiltersKey.Value.BestSeller": "Best Seller",
    "AdvancedFilters.transpileFiltersKey.Value.Premium": "Premium",
    "AdvancedFilters.transpileFiltersKey.Value.ItemCost.FromTo": "from {{from}} to {{to}}",

    "Search.Header.PlaceHolder.Search": "Enter keywords…",
    "Search.Header.Button.Search": "Search",
    "Search.Header.Button.Filters": "Filters",

    "Navigation.UpgradeButton.TryPro": "Try Spocket Pro for FREE",
    "Navigation.UpgradeButton.TryEmpire": "Try Spocket EMPIRE for FREE",
    "Navigation.UpgradeButton.TryUnicorn": "Try Spocket Unicorn for FREE",

    "CategoriesCards.Label.MoreCategories": "More Categories",

    "StaticCategories.WomensClothing": "Women's Clothing",
    "StaticCategories.WomensClothing.Activewear": "Activewear",
    "StaticCategories.WomensClothing.Bodysuits": "Bodysuits",
    "StaticCategories.WomensClothing.Dresses": "Dresses",
    "StaticCategories.WomensClothing.JacketsCoats": "Jackets & Coats",
    "StaticCategories.WomensClothing.Jeans": "Jeans",
    "StaticCategories.WomensClothing.JumpsuitsRompers": "Jumpsuits & Rompers",
    "StaticCategories.WomensClothing.Leggings": "Leggings",
    "StaticCategories.WomensClothing.LingerieUnderwear": "Lingerie & Underwear",
    "StaticCategories.WomensClothing.MatchingSets": "Matching Sets",
    "StaticCategories.WomensClothing.Pants": "Pants",
    "StaticCategories.WomensClothing.Shorts": "Shorts",
    "StaticCategories.WomensClothing.Skirts": "Skirts",
    "StaticCategories.WomensClothing.Sleepwear": "Sleepwear",
    "StaticCategories.WomensClothing.Socks": "Socks",
    "StaticCategories.WomensClothing.SweatersHoodies": "Sweaters & Hoodies",
    "StaticCategories.WomensClothing.Swimwear": "Swimwear",
    "StaticCategories.WomensClothing.TankTops": "Tank Tops",
    "StaticCategories.WomensClothing.TopsBlouses": "Tops & Blouses",
    "StaticCategories.WomensClothing.Tshirts": "T-shirts",

    "StaticCategories.JewelryWatches": "Jewelry & Watches",
    "StaticCategories.JewelryWatches.Bracelets": "Bracelets",
    "StaticCategories.JewelryWatches.Earrings": "Earrings",
    "StaticCategories.JewelryWatches.Necklaces": "Necklaces",
    "StaticCategories.JewelryWatches.OtherAccessories": "Other Accessories",
    "StaticCategories.JewelryWatches.PendantsStonesCharms": "Pendants, Stones & Charms",
    "StaticCategories.JewelryWatches.Rings": "Rings",
    "StaticCategories.JewelryWatches.Sets": "Sets",
    "StaticCategories.JewelryWatches.Watches": "Watches",

    "StaticCategories.TechAccessories": "Tech Accessories",
    "StaticCategories.TechAccessories.AudioVideo": "Audio & Video",
    "StaticCategories.TechAccessories.CasesCovers": "Cases & Covers",
    "StaticCategories.TechAccessories.Lighting": "Lighting",
    "StaticCategories.TechAccessories.MobileLaptopAccessories": "Mobile & Laptop Accessories",
    "StaticCategories.TechAccessories.Mousepads": "Mousepads",
    "StaticCategories.TechAccessories.Novelty": "Novelty",

    "StaticCategories.KidsBabies": "Kids & Babies",
    "StaticCategories.KidsBabies.BabyClothing": "Baby Clothing",
    "StaticCategories.KidsBabies.Bathing": "Bathing",
    "StaticCategories.KidsBabies.BlanketsPillows": "Blankets & Pillows",
    "StaticCategories.KidsBabies.CapsHeadbands": "Caps & Headbands",
    "StaticCategories.KidsBabies.Footwear": "Footwear",
    "StaticCategories.KidsBabies.Furniture": "Furniture",
    "StaticCategories.KidsBabies.KidsClothing": "Kid's Clothing",
    "StaticCategories.KidsBabies.ParenthoodAccessories": "Parenthood & Accessories",

    "StaticCategories.Toys": "Toys",
    "StaticCategories.Footwear": "Footwear",
    "StaticCategories.Footwear.Boots": "Boots",
    "StaticCategories.Footwear.Flats": "Flats",
    "StaticCategories.Footwear.Heels": "Heels",
    "StaticCategories.Footwear.Mens": "Mens",
    "StaticCategories.Footwear.Sandals": "Sandals",
    "StaticCategories.Footwear.Slippers": "Slippers",
    "StaticCategories.Footwear.SneakersRunners": "Sneakers & Runners",

    "StaticCategories.BathBeauty": "Bath & Beauty",
    "StaticCategories.BathBeauty.Bodycare": "Bodycare",
    "StaticCategories.BathBeauty.DiffusersOilsCandles": "Diffusers, Oils & Candles",
    "StaticCategories.BathBeauty.Haircare": "Haircare",
    "StaticCategories.BathBeauty.Healthcare": "Healthcare",
    "StaticCategories.BathBeauty.Makeup": "Makeup",
    "StaticCategories.BathBeauty.Nails": "Nails",
    "StaticCategories.BathBeauty.Skincare": "Skincare",
    "StaticCategories.BathBeauty.TowelsRobes": "Towels & Robes",

    "StaticCategories.Pets": "Pets",
    "StaticCategories.Pets.BedsBlankets": "Beds & Blankets",
    "StaticCategories.Pets.LeashesCollarsPetwear": "Leashes, Collars & Petwear",
    "StaticCategories.Pets.Petcare": "Petcare",
    "StaticCategories.Pets.Toys": "Toys",

    "StaticCategories.HomeGarden": "Home & Garden",
    "StaticCategories.HomeGarden.Bathroom": "Bathroom",
    "StaticCategories.HomeGarden.Clocks": "Clocks",
    "StaticCategories.HomeGarden.Drinkware": "Drinkware",
    "StaticCategories.HomeGarden.FoodBeverage": "Food & Beverage",
    "StaticCategories.HomeGarden.Furniture": "Furniture",
    "StaticCategories.HomeGarden.Garden": "Garden",
    "StaticCategories.HomeGarden.HomeDecor": "Home Decor",
    "StaticCategories.HomeGarden.HomeImprovement": "Home Improvement",
    "StaticCategories.HomeGarden.Kitchen": "Kitchen",
    "StaticCategories.HomeGarden.Lighting": "Lighting",
    "StaticCategories.HomeGarden.Organization": "Organization",
    "StaticCategories.HomeGarden.StationeryCrafts": "Stationery & Crafts",
    "StaticCategories.HomeGarden.TextilesPillows": "Textiles & Pillows",
    "StaticCategories.HomeGarden.Tools": "Tools",

    "StaticCategories.Accessories": "Accessories",
    "StaticCategories.Accessories.Belts": "Belts",
    "StaticCategories.Accessories.Cufflinks": "Cufflinks",
    "StaticCategories.Accessories.Hats": "Hats",
    "StaticCategories.Accessories.Keychains": "Keychains",
    "StaticCategories.Accessories.ScarvesBandanas": "Scarves & Bandanas",
    "StaticCategories.Accessories.Sunglasses": "Sunglasses",

    "StaticCategories.MensClothing": "Men's Clothing",
    "StaticCategories.MensClothing.Activewear": "Activewear",
    "StaticCategories.MensClothing.DressShirts": "Dress Shirts",
    "StaticCategories.MensClothing.JacketsCoats": "Jackets & Coats",
    "StaticCategories.MensClothing.Pants": "Pants",
    "StaticCategories.MensClothing.Shorts": "Shorts",
    "StaticCategories.MensClothing.Socks": "Socks",
    "StaticCategories.MensClothing.SweatersHoodies": "Sweaters & Hoodies",
    "StaticCategories.MensClothing.Swimwear": "Swimwear",
    "StaticCategories.MensClothing.TankTops": "Tank Tops",
    "StaticCategories.MensClothing.Tshirts": "T-shirts",
    "StaticCategories.MensClothing.Underwear": "Underwear",

    "StaticCategories.SportsOutdoors": "Sports & Outdoors",
    "StaticCategories.SportsOutdoors.Activewear": "Activewear",
    "StaticCategories.SportsOutdoors.Biking": "Biking",
    "StaticCategories.SportsOutdoors.Camping": "Camping",
    "StaticCategories.SportsOutdoors.EquipmentAccessories": "Equipment & Accessories",
    "StaticCategories.SportsOutdoors.Fishing": "Fishing",

    "StaticCategories.Gifts": "Gifts",
    "StaticCategories.Gifts.Adults": "Adults",
    "StaticCategories.Gifts.Funny": "Funny",
    "StaticCategories.Gifts.Mugs": "Mugs",
    "StaticCategories.Gifts.Novelty": "Novelty",
    "StaticCategories.Gifts.Personalized": "Personalized",
    "StaticCategories.Gifts.Religious": "Religious",

    "StaticCategories.Automotive": "Automotive",
    "StaticCategories.BagsWallets": "Bags & Wallets",
    "StaticCategories.Seasonal": "Seasonal",
    "StaticCategories.Seasonal.Christmas": "Christmas",
    "StaticCategories.Seasonal.FathersDay": "Father's Day",
    "StaticCategories.Seasonal.Halloween": "Halloween",
    "StaticCategories.Seasonal.MothersDay": "Mother's Day",

    "StaticCategories.FestivalsParties": "Festivals & Parties",
    "StaticCategories.FestivalsParties.PartySupplies": "Party Supplies",
    "StaticCategories.FestivalsParties.Wedding": "Wedding",

    "QuickFilters.Label.ShipsFromUSA": "Ships from USA",
    "QuickFilters.Label.ShipsFromEU": "Ships from EU",
    "QuickFilters.Label.Premium": "Premium",
    "QuickFilters.Label.FastUSAShipping": "Fast USA shipping",
    "QuickFilters.Label.Under5": "USA shipping under $5",

    "SortBy.Label.SortBy": "Sort by",
    "SortBy.DropDown.Item.Relevance": "Relevance",
    "SortBy.DropDown.Item.PriceLowToHigh": "Price: low to high",
    "SortBy.DropDown.Item.PriceHighToLow": "Price: high to low",
    "SortBy.DropDown.Item.Newest": "Newest",
    "SortBy.DropDown.Item.ShippingTime": "Shipping time",

    "Breadcrumb.Item.Home": "Home",
    "Breadcrumb.Item.Search": "Search",

    "UpgradeModal.Modal.Title": "Select a pricing plan",

    "Plans.ToggleSection.Monthly": "Monthly",
    "Plans.ToggleSection.Yearly": "Yearly",
    "Plans.ToggleSection.DiscountInitial": "Get Up to",
    "Plans.ToggleSection.DiscountSingular": "Month",
    "Plans.ToggleSection.DiscountPlural": "Months",
    "Plans.ToggleSection.DiscountFinal": "Off",
    "Plans.ProrationCost.TextInitial": "You are currently paying",
    "Plans.ProrationCost.TextFinal": "/yr. Upgrade to Empire for only an additional",

    "Card.Title.PeriodSingular": "MONTH",
    "Card.Title.PeriodPlural": "MONTHS",
    "Card.Title.Off": "OFF",
    "Card.DescriptionVariantType.Starter": "Start getting sales",
    "Card.DescriptionVariantType.Professional": "Boost sales",
    "Card.DescriptionVariantType.Empire": "Maximize sales",
    "Card.DescriptionVariantType.Unicorn": "Manage sales at scale",
    "Card.DescriptionVariantType.Period": "mo",
    "Card.DescriptionVariantType.PricePeriod": "{{value}}/mo",
    // eslint-disable-next-line
    "Card.DescriptionVariantType.AnnualDescription": "billed annually at ${{value}}",
    "Card.DescriptionVariantType.MonthlyDescription": "after the {{value}}-day trial",
    "Card.DescriptionVariantType.CurrentPlan": "Your current plan",
    "Card.DescriptionVariantType.Button.Start": "Start now",
    "Card.DescriptionVariantType.Button.Try": "Try it for free",
    "Card.DescriptionVariantType.UniqueProducts": "unique products",
    "Card.DescriptionVariantType.PremiumProducts": "premium products",
    "Card.DescriptionVariantType.EmailSupport": "Email support",
    "Card.DescriptionVariantType.Invoicing": "Branded invoicing",
    "Card.DescriptionVariantType.InvoicingTooltip": "Build your brand by adding your own logo to all orders from suppliers who offer branded invoicing",
    "Card.DescriptionVariantType.ChatSupport": "Chat support",
    "Card.DescriptionVariantType.WinningProducts": "Winning Products",
    "Card.DescriptionVariantType.SupplierSourcing": "Supplier sourcing",
    "Card.DescriptionVariantType.ProductRequests": "Product requests",
    "Card.DescriptionVariantType.ProductRequestsTooltip": "Request products that aren’t already on Spocket",
    "Card.DescriptionVariantType.BulkCheckout": "Bulk checkout",
    "Card.DescriptionVariantType.BulkCheckoutTooltip": "Checkout multiple orders at once with the click of a button",
    "Card.DescriptionVariantType.Special": "special",

    "ReactivationBanner.Alert": "Your Spocket subscription has ended.",
    "ReactivationBanner.InfoSubtitle": "Reactivate your",
    "ReactivationBanner.CheckList.HighQuality": "High quality",
    "ReactivationBanner.CheckList.Curated": "Curated",
    "ReactivationBanner.CheckList.FastShipping": "Fast Shipping",
    "ReactivationBanner.CheckList.FromUSAndEU": "From US and EU",
    "ReactivationBanner.TextByPlan.Starter.Description": "You will no longer be able to <1>push any Products</1>",
    "ReactivationBanner.TextByPlan.Starter.Title": "Spocket Account",
    "ReactivationBanner.TextByPlan.Starter.Subtitle": "Start pushing products to your store now",
    "ReactivationBanner.TextByPlan.Others.Description.PartOne": "You are no longer be able to <1>Push Products</1> live or use ",
    "ReactivationBanner.TextByPlan.Others.Description.PartTwo": "Premium Products",
    "ReactivationBanner.TextByPlan.Others.Title": "Premium Account",
    "ReactivationBanner.TextByPlan.Others.Subtitle": "Get access to Premium Products that are",
    "ReactivationBanner.Button": "Reactivate my account NOW",

    "AnnualPromotionModal.Header": "Congratulations, you’re now on the {{planName}} plan",
    "AnnualPromotionModal.CountdownTitle": "Ends in",
    "AnnualPromotionModal.Button.Yes": "Upgrade to annual",
    "AnnualPromotionModal.Button.No": "No, continue with my monthly plan subscription",

    "UpgradeReasonModal.Benefits.IncreasedProducts": "More Product Pushes",
    "UpgradeReasonModal.Benefits.UnlimitedOrders": "Unlimited Orders",
    "UpgradeReasonModal.Benefits.BrandedInvoicing": "Branded Invoicing",
    "UpgradeReasonModal.Benefits.PremiumProducts": "Premium Products",
    "UpgradeReasonModal.Benefits.ExclusiveDeals": "Exclusive Deals",
    "UpgradeReasonModal.Benefits.ChatCallSupport": "Chat & Call Support",
    "UpgradeReasonModal.Modal.Title": "What do you want to achieve with Spocket?",
    "UpgradeReasonModal.Modal.Question": "What made you upgrade?",
    "UpgradeReasonModal.Modal.Button": "Start Using Spocket {{plan}}",
    "UpgradeReasonModal.UpgradeComment.PlaceHolder": "It helps us improve your experience",

    "UpgradeSuccessModal.Col.One.A": "Congratulations.",
    "UpgradeSuccessModal.Col.One.B": "You are now on the {{alias}} plan!",
    "UpgradeSuccessModal.Col.Two.A": "You’ve unlocked all the tools you need to build a successful dropshipping business.",
    "UpgradeSuccessModal.Col.Two.B": "You can now have ",
    "UpgradeSuccessModal.Col.Two.C": " Happy Spocketing!",
    "UpgradeSuccessModal.Button": "Continue",

    "Promotion.TrialDaysNormalizer.30days": "1 month",
    "Promotion.TrialDaysNormalizer.28days": "4 weeks",
    "Promotion.TrialDaysNormalizer.21days": "3 weeks",
    "Promotion.TrialDaysNormalizer.14days": "2 weeks",
    "Promotion.TrialDaysNormalizer.7days": "1 week",
    "Promotion.TrialDaysNormalizer.1day": "1 day",
    "Promotion.TrialDaysNormalizer.Days": "{{value}} days",
    "Promotion.TrialDaysPlan.Title": "Try Spocket Pro now and get 2 weeks free!",
    "Promotion.TrialDaysPlan.Text": "Try Spocket Pro now and get {{value}} free!",
    "Promotion.Button": "Try for free",
    "StickyPromotion.Text": "Try Spocket Pro free for",
    "StickyPromotion.Button": "Try now →",
    "Onboarding.Steps.Title": "Boost your stores sales!",
    "Onboarding.Steps.Subtitle": "Spocket tip: a typical store pushes 25 products before getting sales",
    "Steps.ChecklistItem.Connect.Text": "Connect your account",
    "Steps.ChecklistItem.Connect.Tooltip": "Connect your account to your Shopify or WooCommerce store",
    "Steps.ChecklistItem.Connect.Disabled": "",
    "Steps.ChecklistItem.Search.Text": "Search products & add to Import list",
    "Steps.ChecklistItem.Search.Tooltip": "Find awesome products from US/EU based suppliers and add them to your import list.",
    "Steps.ChecklistItem.Search.Disabled": "",
    "Steps.ChecklistItem.Push.Text": "Push products to your store",
    "Steps.ChecklistItem.Push.Tooltip": "Personalize products in your import list and push them to your store in 1 click.",
    "Steps.ChecklistItem.Push.Disabled": "",
    "Steps.ChecklistItem.Review.Text": "Leave Spocket a review!",
    "Steps.ChecklistItem.Review.Tooltip": "Loving your experience so far? Share it with others!",
    "Steps.ChecklistItem.Review.Disabled": "Connect Account",

    "BubbleWidget.Head.Title":"Hello",
    "BubbleWidget.Head.Subtitle":"Welcome to Spocket Support",
    "BubbleWidget.HelpCenter.Title":"Help Center",
    "BubbleWidget.HelpCenter.Subtitle":"Advice and answers from the Spocket Team",
    "BubbleWidget.EmailUs.Title":"Email Us",
    "BubbleWidget.EmailUs.Subtitle":"Reach out to us with your questions",
    "BubbleWidget.ChatWithUs.Title":"Chat With Us",
    "BubbleWidget.ChatWithUs.Subtitle.Basic":"For Pro & Empire Users",
    "BubbleWidget.ChatWithUs.Subtitle.NotBasic":"Our support agents are waiting",
    "BubbleWidget.ChatWithUs.Subtitle.Unlock":"Unlock now",
    "BubbleWidget.Community.Title":"Community",
    "BubbleWidget.Community.Subtitle":"Join the community of 50,000+ dropshippers",
    "BubbleWidget.StoreReviews.Title":"Store Reviews",
    "BubbleWidget.StoreReviews.Subtitle":"Pro & Empire Users",
    "BubbleWidget.StoreReviews.Unlock":"Unlock now",

    "Language.Title": "Language",

    "WhatYouWillLoseModal.Button.Offer": "Keep going",
    "WhatYouWillLoseModal.Button.Downgrade": "I give up, downgrade my account",
    "WhatYouWillLoseModal.ProductSection.Title": "You’ll lose all <1>{{product_count}} imported products</1>",
    "WhatYouWillLoseModal.Product.PremiumTag": "Premium",
    "WhatYouWillLoseModal.Product.SkeletonImage": "+ {{product_count}} more",
    "WhatYouWillLoseModal.ModalWrapper.Header": "are you giving up already?",
    "WhatYouWillLoseModal.ModalWrapper.Title.Tag": "Get 50% off",
    "WhatYouWillLoseModal.ModalWrapper.Title": "Continue your entrepreneurial journey for the next 3 months.",
    "WhatYouWillLoseModal.ModalWrapper.Subtitle": "We want you to be another success story. We know you have already invested a lot of time. So keep going. We are all rooting for you. Team Spocket",

    "FiftyOff3MonthsOfferSuccessModal.Header": "Congratulations, we have now added a 50% discount to your plan for the next 3 months!",
    "FiftyOff3MonthsOfferSuccessModal.Button": "Continue",

    "DowngradeReasonModal.DowngradeSection": "How can we make Spocket work better for you?",
    "DowngradeReasonModal.DowngradeSection.TextArea.PlaceHolder": "We want your feedback about everything (100 character minimum)",
    "DowngradeReasonModal.DowngradeSection.Tooltip": "Please enter your feedback (100 character minimum)",
    "DowngradeReasonModal.Button.Downgrade": "Downgrade",
    "DowngradeReasonModal.ModalWrapper.Header": "Downgrade {{storeName}}?",
    "DowngradeReasonModal.ModalWrapper.ContactUs": "Contact us",
    "DowngradeReasonModal.ModalWrapper.Footer.Button.Cancel": "Cancel",

    "DowngradeSuccessModal.Header": "Downgrade Successful",
    "DowngradeSuccessModal.Body": "Thank you for your feedback. We are constantly improving Spocket everyday, hope you give us another chance soon!",

    "Settings.title": "Setting",
    "Settings.buttonSaveChanges": "Save Changes",
    "Settings.buttonSaveAndPreview": "Save and Preview",

    "AccountTab.documentTitle": "Settings - Account - Spocket",
    "AccountTab.title": "Account Setting",
    "AccountTab.shopName": "Shop Name",
    "AccountTab.email": "Email",
    "AccountTab.shopUrl": "Shop URL",
    "AccountTab.defaultCurrency": "Default Currency",
    "AccountTab.yourPlan": "Your Plan",
    "AccountTab.accountNotActive": "Your account is not currently active",
    "AccountTab.alertFeatureWillBeAddedSoon": "This feature will be added soon! For now, please connect through the Spocket Shopify app!",
    "AccountTab.alertAccountSettingsUpdated": "Account settings updated",
    "AccountTab.alertInvalidShopUrl": "Invalid Shop URL",
    "AccountTab.productsImported": "Products Imported",
    "AccountTab.products": "Products",
    "AccountTab.premiumProducts": "Premium Products",
    "AccountTab.total": "total",
    "AccountTab.signOut": "Sign Out",
    "AccountTab.limitReachedProductsAndPremium": "Products and Premium Products limit reached.",
    "AccountTab.limitReachedProducts": "Products limit reached.",
    "AccountTab.limitReachedPremium": "Premium Products limit reached.",
    "AccountTab.buttonSwitchToAnnualPlan": "Switch to Annual Plan",
    "AccountTab.off30Percent": "30% Off",
    "AccountTab.off40Percent": "40% Off",
    "AccountTab.off45Percent": "45% Off",
    "AccountTab.sellMoreWithEmpirePlan": "Sell More with Empire Plan",
    "AccountTab.tooltipCurrency":"Your currency is managed via your store account. All prices for your imported products will be converted to that currency.",
    "AccountTab.shopNotConnectedYet": "Your shop has not been connected with this account yet.",
    "AccountTab.connectYourShop": "Connect Your Shop",

    "InvoiceTab.documentTitle": "Settings - Invoicing - Spocket",
    "InvoiceTab.alertInvoiceSettingSaved": "Invoice settings saved!",
    "InvoiceTab.shopLogo": "Shop Logo",
    "InvoiceTab.contactEmail": "Contact Email",
    "InvoiceTab.phoneNumber": "Phone Number",
    "InvoiceTab.personalNote": "Personal Note",
    "InvoiceTab.tooltipPersonalNote": "Set a personal note to be included in each of your branded invoices",
    "InvoiceTab.brandedInvoicing": "Branded Invoicing",
    "InvoiceTab.tooltipBrandedInvoicing": "Add your brands logo and a personal note to all orders from suppliers who offer branded invoicing when on a paid plan",
    "InvoiceTab.disabledInvoicing": "Include Branded Invoicing on All Orders",
    "InvoiceTab.tooltipDisabledInvoicing": "Turning off this option will exclude branded invoicing when you place your orders",

    "PricingTab.titleDefaultPricingRules": "Default Pricing Rules",
    "PricingTab.tooltipTitleDefaultPricingRules": "From here you can assign a fixed markup or multiplier that will apply to all of your products",
    "PricingTab.titleAdvancedPricingRules": "Advanced Pricing Rules",
    "PricingTab.tooltipTitleAdvancedPricingRules": "Advanced rules let you set your markups or multipliers based on product price ranges.",
    "PricingTab.assignCents": "Assign Cents",
    "PricingTab.tooltipAssignCents": "This value will be used when displaying the final price for your items (e.g., if you want the cost of your product to be XX.99 then add 99 to the fields below).",
    "PricingTab.Markup": "Markup",
    "PricingTab.MarkupType": "Markup Type",
    "PricingTab.SelectDefault": "-- Select One --",
    "PricingTab.SelectPercent": "Percent",
    "PricingTab.SelectMultiplier": "Multiplier",
    "PricingTab.SelectFixed": "Fixed",
    "PricingTab.titlePricingRules": "Settings - Pricing Rules - Spocket",
    "PricingTab.toggleAdvancedPricingRules": "Toggle Advanced Pricing Rules",
    "PricingTab.from": "From",
    "PricingTab.to": "To",
    "PricingTab.selectMultiplier": "Multiplier",
    "PricingTab.selectFixedAmount": "Fixed Amount",
    "PricingTab.buttonRemove": "Remove",
    "PricingTab.alertCannotCreateMoreThanOneRuleWithEmptyFields": "You cannot create more than one rule with empty fields",
    "PricingTab.costRange": "Cost Range",
    "PricingTab.markup": "Markup",
    "PricingTab.add": "Add",

    "SecurityTab.Document.Title": "Settings - Security - Spocket",
    "SecurityTab.alertIncorrectPassword": "Incorrect Password",
    "SecurityTab.title": "Security",
    "SecurityTab.yourNewPassword": "Your New Password",
    "SecurityTab.repeatPassword": "Repeat Password",
    "SecurityTab.errorPleaseEnterAPassword": "Please enter a password.",
    "SecurityTab.errorPasswordsConfirmationNeeded": "Please enter a password confirmation.",
    "SecurityTab.errorPasswordsDoNotMatch": "Passwords do not match",
    "SecurityTab.errorPasswordShort": "Password must be 8 characters or longer",

    "ListingCards.TopSupplierTag.Tooltip": "Top Suppliers are known for their high-quality products, great service and high ratings",
    "ListingCards.TopSupplierTag.Text": "Supplier",

    "ListingCard.OriginCountry.Intro":"By",
    "ListingCard.OriginCountry.Tooltip":"Ships from",
    "ListingCard.Shipping.Price.Title":"Shipping Price",
    "ListingCard.Shipping.Price.Free":"FREE",
    "ListingCard.Price.Intro":"Price",
    "ListingCard.Price.Retail":"Retail Price",
    "ListingCard.Shipping.Time.Title":"Shipping Time",
    "ListingCard.Shipping.Time.Period":"days",
    "ListingCard.PremiumIcon.Tooltip":"Sell exclusive, highly discounted and fast shipping products on your shop",
    "ListingCard.PremiumIcon.Text":"Premium",
    "ListingCard.ListButton.Import":"Add to Import List",
    "ListingCard.ListButton.Remove":"Remove from Import list",
    "ListingCard.ListButton.Pushed":"Pushed to Store",

    "ListingModal.MainSection.Title":"Product Description",
    "ListingModal.DetailsSection.Button.ProductVariations":"Open Product Variations",
    "ListingModal.DetailsSection.Button.OrderSamples":"Order Samples",
    "ListingModal.DetailsSection.Button.OrderSamples.New":"New",
    "ListingModal.DetailsSection.BrandedInvoicing.Alert":"Branded Invoicing is not available for this product",
    "ListingModal.DetailsSection.InternationalShipping.Alert":"International orders will be shipped from our warehouse in China",
    "ListingModal.DetailsSection.StockUsa.Alert":"Items that are out-of-stock in the USA warehouse may be sent from our China warehouse",
    "ListingModal.DetailsSection.MultiplePackage.Alert":"Orders may be sent in multiple packages to help reduce overall shipping time on your orders",
    "ListingModal.DetailsSection.ConnectStore.Alert":"Connect your store to place order",
    "ListingModal.DetailsSection.PushedListButton":"Pushed to Store",
    "ListingModal.DetailsSection.RemoveListButton":"Remove from List",
    "ListingModal.DetailsSection.ImportListButton":"Add to Import List",
    "ListingModal.DetailsSection.ImportListButton.Deactivated":"Listing Deactivated",

    "InfoSection.ShippingTime.Tooltip": "Number of days for the product to be delivered after being shipped.",
    "InfoSection.ShippingTime.Title": "Shipping Time",
    "InfoSection.ShippingInfo.Worldwide": "Worldwide",
    "InfoSection.ShippingExcluded.Intro": "Does not ship to",
    "InfoSection.ShippingExcluded.Various": "Various",
    "InfoSection.ProcessingTime.Tooltip": "Number of business days for the supplier to ship and provide tracking number",
    "InfoSection.ProcessingTime.Title": "Processing Time",
    "InfoSection.ProcessingTime.Period": "business days",
    "InfoSection.ShippingInfoLine.Tooltip": "This product ships for {{price_formatted}}, plus {{incremental_price_formatted}} for each additional product in the same order",
    "InfoSection.ShippingInfoLine.Period": "business days",
    "InfoSection.ShippingInfoLine.Free": "FREE",
    "InfoSection.ShippingInfoLine.NoShipping": "Does not ship",

    "ReturnPolicySection.Title": "Return Policy",

    "TitleSection.TitleCountryOrigin.CountryOrigin.Intro": "From",
    "TitleSection.TitleCountryOrigin.SupplierShopName.Intro": "By",
    "TitleSection.PriceMSRP.Listing": "Listing Price",
    "TitleSection.PriceMSRP.Retail": "Retail Price",

    "ProductVariationsModal.Title": "Product Variations",
    "ProductVariationsModal.Table.Image": "Image",
    "ProductVariationsModal.Table.Inventory": "Inventory",
    "ProductVariationsModal.Table.Price": "Price",
    "ProductVariationsModal.ImageSpecifications.Title": "Size Chart",
    "ProductVariationsModal.ImageSpecifications.Button": "Download",

    "TopSupplier.Tooltip": "Top Suppliers are known for their high-quality products, great service and high ratings",
    "TopSupplier.Text": "Top Supplier",

    "BestSelling.SharedComponents.Text": "Best Selling Product",
    "BestSelling.Tooltip.Top": "This is a top performing product on Spocket",
    "BestSelling.Tooltip.Bottom": "Best Seller",

    "GallerySection.PremiumIcon.Tooltip": "Sell exclusive, highly discounted and fast shipping products on your shop",
    "GallerySection.PremiumIcon.Text": "Premium",
    "GallerySection.DiscountStamp.Text": "Extra {{value}}% Off",

    "Upgrade.Title.AnnualToggled": "Get Spocket premium today",
    "Upgrade.Title.MonthlyToggled": "Try Spocket premium free for 14 days",
    "Upgrade.Subtitle": "Try a Spocket premium plan today and start adding high converting products from the US and Europe to your store.",
    "Upgrade.Button": "Continue without Spocket premium",

    "Search.NoProductsFound.Title": "Sorry! We couldn’t find any results",
    "Search.NoProductsFound.For": "for",
    "Search.NoProductsFound.Description": "Please check the spelling, try a related search term or a more general search term.",
    "Search.Searching.Title": "We are searching for products...",
    "Search.Searching.Description": "Please wait while we load the latest products for you.",
    
    "Suppliers.StarRating.Tooltip": "Supplier order fulfillment success rate",
    "Suppliers.RefundPolicy": "Supplier’s refund policy",
    "Suppliers.Joined.Title": "Joined Spocket",
    "Suppliers.Origin.Title": "Shipping from country",
    "Suppliers.Time.Title": "Average shipping time",
    "Suppliers.HasMore.Title": "We are searching for products...",
    "Suppliers.HasMore.Subtitle": "Please wait while we load the latest products for you.",
    "Suppliers.TopSupplierTag.Tooltip": "Top Suppliers are known for their high-quality products, great service and high ratings",
    "Suppliers.TopSupplierTag.Text": "Top Supplier",

    "AltTextModal.Header.Title": "Edit Image Details",
    "AltTextModal.Body.Description": "Write a brief description of this image to improve search engine optimization (SEO) and accessibility for visually impaired customers.",
    "AltTextModal.Input.Label": "Alt Text",
    "AltTextModal.Input.Placeholder": "Image ALT Text",
    "AltTextModal.Button.Cancel": "Cancel",
    "AltTextModal.Button.Save": "Save",

    "WistiaModal.WhatIsSpocket.Title": "What is Spocket?",
    "WistiaModal.WhatIsSpocket.Text": "Learn how Spocket can help you build your business. Understand how Spocket works and how you can make the most of it.",
    "WistiaModal.WhatIsSpocket.Button": "Start Finding Products",
    "WistiaModal.DiscoverProducts.Title": "Discover Products",
    "WistiaModal.DiscoverProducts.Text": "Find the right products with the help of adequate filters, and add them to your store.",
    "WistiaModal.DiscoverProducts.Button": "Start Finding Products",
    "WistiaModal.ProductCustomization.Title": "Customize your Products",
    "WistiaModal.ProductCustomization.Text": "Use the Import List to modify your products to suit your store. You can edit the product descriptions, set the prices, add the product to a collection as well as remove images.",
    "WistiaModal.ProductCustomization.Button": "Go to Import List",
    "WistiaModal.OrderProcessing.Title": "Automated Order Processing",
    "WistiaModal.OrderProcessing.Text": "Fulfill your orders, and have the supplier deliver the product right to your customer’s doorstep in one click.",
    "WistiaModal.OrderProcessing.Button": "Go to Orders",
    "WistiaModal.Settings.Title": "Settings",
    "WistiaModal.Settings.Text": "The settings page allows you to manage all your account information, brand your invoice and add your credit card. You can also adjust pricing rules for all your products and choose a subscription plan.",
    "WistiaModal.Settings.Button": "Setup Your Account",
  }
};



// WEBPACK FOOTER //
// ./src/utils/i18n/en.js